<template>
	<div class="self-signup-message">
		<v-icon size="64" color="grey darken-1">mdi-alert-circle-outline</v-icon>
		<h1 class="mt-4 mb-3">Une erreur est survenue</h1>
		<p class="text-center message-body">Une erreur est survenue, veuillez contacter votre administrateur.</p>
	</div>
</template>

<script>
export default {
	name: 'SelfSignupError',
};
</script>

<style lang="scss" scoped>
.self-signup-message {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 40vh;
	text-align: center;
	padding: 24px;
}
.message-body {
	max-width: 420px;
	color: #555;
}
</style>
